import { css, DefaultTheme } from 'styled-components';
import { ThemeType } from '../constants';
import { FontWeight } from '../../constants';

export const isDarkTheme = (theme: DefaultTheme) =>
  theme.mode === ThemeType.dark;
export const isLightTheme = (theme: DefaultTheme) =>
  theme.mode === ThemeType.light;

export const getDefaultMenuItemColor = (theme: DefaultTheme) =>
  isDarkTheme(theme) ? 'rgba(254, 254, 254, 0.70)' : theme.colors.text.primary;

export const getHoverMenuItemColor = (theme: DefaultTheme) =>
  isDarkTheme(theme)
    ? theme.colors.text.primary
    : theme.colors.systemColors.blue;

export const getSelectedMenuItemStyles = (theme: DefaultTheme) => {
  const {
    colors: { systemColors, text }
  } = theme;

  return css`
    color: ${isLightTheme(theme) ? systemColors.brand : text.primary};
    font-weight: ${FontWeight.medium};
  `;
};
